// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8da78b8b","283":"3b6d5537","324":"71d034fc","453":"821fd3de","713":"1e7e525b","773":"bdd394ab","780":"72ac5c23","831":"5d65746d","842":"8310f334"}[chunkId] + ".chunk.js";
};